import { useContext, useState, useEffect } from 'react';
import { ExperimentContext } from '../context/ExperimentClient.js';
import 'hoist-non-react-statics';

var useExperiment = function (_a) {
    var experiment = _a.experiment, defaultTreatment = _a.defaultTreatment, attributes = _a.attributes, options = _a.options, overrideId = _a.overrideId;
    var identifiedExperimentClient = useContext(ExperimentContext);
    // Attempt to get treatment to set initial state if client is already initialized
    // The experiment client should always be pre-initialized for both client and server
    var treatment = identifiedExperimentClient.treatment({
        experiment: experiment,
        defaultTreatment: defaultTreatment,
        attributes: attributes,
        options: options,
        overrideId: overrideId
    });
    var _b = useState(treatment.result ? false : true), loading = _b[0], setLoading = _b[1];
    var _c = useState(treatment.result ? treatment.result : null), result = _c[0], setResult = _c[1];
    useEffect(function () {
        var treatment = identifiedExperimentClient.treatment({
            experiment: experiment,
            defaultTreatment: defaultTreatment,
            attributes: attributes,
            options: options,
            overrideId: overrideId
        });
        if (treatment.result) {
            setResult(treatment.result);
            setLoading(false);
        }
        else {
            // the client is not ready yet
            treatment.promise.then(function (result) {
                setLoading(false);
                setResult(result);
            });
        }
    }, [experiment, defaultTreatment, attributes, options]);
    if (options && options.skip) {
        return { result: defaultTreatment, loading: false };
    }
    return { result: result, loading: loading };
};

export { useExperiment };
//# sourceMappingURL=useExperiment.js.map
